module.exports = __webpack_public_path__ + "img/innova-wood-belgium.c7d85320.png";